import { Checkbox, FormControlLabel } from "@mui/material";
import PageTitleSubtitle from "../PageTitleSubTitle";

export default function FieldCheckbox({
  fieldTitle,
  fieldSubtitle,
  fieldName,
  valueChecked,
  valueOnChecked,
  valueOnUnchecked,
  handleCheckedChanged,
  customMinWidth,
}) {
  return (
    <div className="w-full flex justify-between items-center my-2 gap-2">
      <div>
        <PageTitleSubtitle
          useFieldTitleStyle
          useEventTitleStyle
          title={fieldTitle}
          subtitle={fieldSubtitle}
        />
      </div>
      <FormControlLabel
        size="small"
        name={fieldName}
        style={{ minWidth: customMinWidth ?? "250px", marginLeft: "15px" }}
        control={
          <Checkbox
            size="small"
            name={fieldName}
            checked={valueChecked}
            onChange={handleCheckedChanged}
          />
        }
        label={
          <span
            style={{
              fontSize: "0.8em",
              color: "black",
            }}
          >
            {valueChecked ? valueOnChecked : valueOnUnchecked}
          </span>
        }
      />
    </div>
  );
}
